/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f32f2abf1f225d229b6be2dfd61a6635>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "CurlyBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/curly-brackets
 * Usage guidance:
 * Known uses: Represents Smart values in Proforma.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const CurlyBracketsIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  name: "CurlyBracketsIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10 1h2.5a2 2 0 0 1 2 2v4.25H16v1.5h-1.5V13a2 2 0 0 1-2 2H10v-1.5h2.5a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H10zM1.5 3a2 2 0 0 1 2-2H6v1.5H3.5A.5.5 0 0 0 3 3v10a.5.5 0 0 0 .5.5H6V15H3.5a2 2 0 0 1-2-2V8.75H0v-1.5h1.5z" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
CurlyBracketsIcon.displayName = 'CurlyBracketsIcon';
var _default = exports.default = CurlyBracketsIcon;